import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { VacanciesSectionProps } from '../types';
import { styled } from '@mui/material';

import { JobDetailsHighlightRow } from '../HighlightRows/HighlightRowJobDetails';
import { DistrictWideBadge } from '../InfoBadges/DistrictWideBadge';
import { CONNECT_ACTION_LABEL } from 'features/Connect/features/JobDiscovery/constants';

interface VacancyRowStackProps {
  isConnectModalView?: boolean;
}

export const VacancyRow: React.FC<VacanciesSectionProps> = ({
  vacancy,
  isConnectModalView = false,
}) => {
  return (
    <VacancyRowStack isConnectModalView={isConnectModalView} direction="row">
      <Stack direction={'column'} gap={0.5}>
        <div style={{ display: 'flex' }}>
          <VacancyTitle>{vacancy.title}</VacancyTitle>
          {vacancy?.pooled_posting_type === 'pooled_posting' && <DistrictWideBadge />}
        </div>
        <VacancySubtitle>{vacancy?.subcategories?.join(', ')}</VacancySubtitle>
        {isConnectModalView && <JobDetailsHighlightRow vacancy={vacancy} />}
      </Stack>
    </VacancyRowStack>
  );
};

export const NoVacanciesSection: React.FC<VacanciesSectionProps> = () => {
  return (
    <NoVacanciesContainer>
      <VacancyTitle>No current job openings</VacancyTitle>
      <VacancySubtitle>
        {`${CONNECT_ACTION_LABEL} for this school to be notified when openings become available`}
      </VacancySubtitle>
    </NoVacanciesContainer>
  );
};

const VacancyRowStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isConnectModalView',
})<VacancyRowStackProps>(({ isConnectModalView, theme }) => ({
  margin: isConnectModalView ? theme.spacing(3, 0, 0, 0) : 'none',
  justifyContent: 'space-between',
  alignContent: 'center',
  textAlign: 'left',
  border: isConnectModalView ? '1px solid #B1ECDB' : 'none',
  borderRadius: theme.shape.borderRadius * 0.5,
  width: '100%',
  height: '100%',
  padding: theme.spacing(2),
  backgroundColor: isConnectModalView ? theme.palette.primary.fill : 'initial',
}));

const NoVacanciesContainer = styled(Box)(({ theme }) => ({
  background: '#FFF',
  border: '1px solid #EAECF0',
  borderRadius: theme.shape.borderRadius * 0.5,
  margin: '4px 0px',
  padding: '16px 14px',
  width: '100%',
}));

const VacancyTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.gray.mediumDark,
}));

const VacancySubtitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightLight,
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.text.light,
}));
